// ====== EDITA AQUÍ TUS DATOS REALES ======
export const CONTACT = {
  // Número de WhatsApp en formato internacional sin signos (solo dígitos)
  whatsapp: "12395025831",
  // Número de WhatsApp para mostrar
  whatsappDisplay: "+1 (239) 502-5831",
  // Número/usuario de Telegram (con + si es número)
  telegram: "+12395025831",
  // Telegram para mostrar
  telegramDisplay: "+1 (239) 502-5831",
  // Email de contacto
  email: "contacto@brothersplustvs.com",
  // Datos de Zelle
  zelleEmail: "dunielbc830911@gmail.com",
  zelleName: "BrothersPlus TV",
  // Datos de Cash App
  cashtag: "BrothersPlustv",
  cashName: "BrothersPlus TV",
};

export const waLink = (text) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;
export const tgLink = () => `https://t.me/${CONTACT.telegram}`;

export const STATS = [
  { value: "13,000+", label: "Canales en vivo" },
  { value: "22,000+", label: "Películas on demand" },
  { value: "3,000+", label: "Series completas" },
  { value: "99.9%", label: "Estabilidad del servidor" },
];

export const PLANS = [
  {
    name: "1 Mes",
    price: "13",
    period: "/mes",
    badge: null,
    bonus: null,
    totalLabel: "1 mes de servicio",
    perMonth: "$13.00/mes",
    savings: null,
    features: ["2 conexiones", "Todos los canales y VOD", "Calidad HD / 4K", "Soporte por chat"],
  },
  {
    name: "3 Meses",
    price: "30",
    period: "/3 meses",
    badge: null,
    bonus: "+1 mes GRATIS",
    totalLabel: "4 meses en total",
    perMonth: "$7.50/mes",
    savings: null,
    features: ["3 conexiones", "Todos los canales y VOD", "Calidad HD / 4K", "Soporte prioritario"],
  },
  {
    name: "6 Meses",
    price: "55",
    period: "/6 meses",
    badge: "Más popular",
    bonus: "+2 meses GRATIS",
    totalLabel: "8 meses en total",
    perMonth: "$6.88/mes",
    savings: "Ahorra 8%",
    features: ["4 conexiones", "Todos los canales y VOD", "Calidad HD / 4K", "Soporte prioritario"],
  },
  {
    name: "12 Meses",
    price: "95",
    period: "/año",
    badge: "Mejor valor",
    bonus: "+3 meses GRATIS",
    totalLabel: "15 meses en total",
    perMonth: "$6.33/mes",
    savings: "Ahorra 15.6%",
    features: ["5 conexiones", "Todos los canales y VOD", "Calidad HD / 4K", "Soporte VIP 24/7"],
  },
];

export const SHOWCASE = [
  { label: "Fútbol en vivo", category: "Deportes", img: "https://images.unsplash.com/photo-1599158150601-1417ebbaafdd?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
  { label: "Películas", category: "Estrenos", img: "https://images.unsplash.com/photo-1701275998609-119e2c09f443?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
  { label: "Series", category: "Maratón", img: "https://images.unsplash.com/photo-1634733049839-0292be607569?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
  { label: "Animados", category: "Infantil", img: "https://static.prod-images.emergentagent.com/jobs/afd65178-8cca-44db-8a8e-fd3fa8b94102/images/5310e83ffb20c9e632aec227f6df11e4a2aabfe178fa1e95384b111de06afc6b.png" },
  { label: "Conciertos", category: "Música", img: "https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
  { label: "Box & UFC", category: "Deportes", img: "https://images.unsplash.com/photo-1552072092-7f9b8d63efcb?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
  { label: "Noticias 24/7", category: "Información", img: "https://static.prod-images.emergentagent.com/jobs/afd65178-8cca-44db-8a8e-fd3fa8b94102/images/7f20f6660418ca9ceed6a40a6dcc060b1e128734c08d390464cc7b9c1a4fb7a5.png" },
  { label: "Baloncesto", category: "Deportes", img: "https://images.unsplash.com/photo-1626003573503-2e088d82c647?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
  { label: "Acción", category: "Cine", img: "https://images.unsplash.com/photo-1462715412043-8d09205be605?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
  { label: "Champions", category: "Deportes", img: "https://images.unsplash.com/photo-1489944440615-453fc2b6a9a9?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
  { label: "Estrenos", category: "Películas", img: "https://images.unsplash.com/photo-1572188863110-46d457c9234d?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
  { label: "Música en vivo", category: "Conciertos", img: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" },
];

export const TESTIMONIALS = [
  {
    name: "Carlos Méndez",
    location: "Miami, EE.UU.",
    rating: 5,
    text: "Llevo 8 meses con BrothersPlus TV y nunca se me ha caído la señal. Veo el fútbol en 4K sin cortes. ¡El mejor servicio que he probado!",
  },
  {
    name: "Yulianny Pérez",
    location: "Madrid, España",
    rating: 5,
    text: "La instalación en mi Smart TV fue rapidísima y el soporte me ayudó por WhatsApp en minutos. Tienen todos los canales que buscaba.",
  },
  {
    name: "Roberto Díaz",
    location: "Bogotá, Colombia",
    rating: 5,
    text: "Una cantidad de películas y series impresionante. Mi familia entera lo usa en diferentes dispositivos. Totalmente recomendado.",
  },
  {
    name: "Adrián Gómez",
    location: "Buenos Aires, Argentina",
    rating: 5,
    text: "Probé otros servicios antes y siempre fallaban. Este es estable de verdad. El plan anual me salió a un precio increíble.",
  },
  {
    name: "Maria Fernández",
    location: "Santo Domingo, R.D.",
    rating: 5,
    text: "Funciona perfecto en mi Firestick y en el iPhone. Me encanta poder ver mis novelas y los canales internacionales desde cualquier lado.",
  },
  {
    name: "Luis Ramírez",
    location: "Houston, EE.UU.",
    rating: 5,
    text: "Atención al cliente de primera y la calidad de imagen es excelente. Renové sin pensarlo dos veces. ¡Gracias BrothersPlus!",
  },
];

export const FAQS = [
  {
    q: "¿Qué es BrothersPlus TV?",
    a: "Es un servicio de IPTV que te da acceso a más de 13,000 canales en vivo, 22,000 películas y 3,000 series desde cualquier parte del mundo.",
  },
  {
    q: "¿En qué dispositivos funciona?",
    a: "Es compatible con Smart TV, Amazon Firestick, dispositivos Android (teléfonos, tablets y TV Box) y dispositivos Apple (iPhone, iPad y Apple TV).",
  },
  {
    q: "¿Necesito una buena conexión a internet?",
    a: "Recomendamos al menos 15 Mbps para contenido en HD y 25 Mbps o más para 4K, garantizando una reproducción estable y sin cortes.",
  },
  {
    q: "¿Cómo recibo mi acceso después de pagar?",
    a: "Tras coordinar tu plan por WhatsApp o Telegram, recibirás tus credenciales y una guía de instalación en pocos minutos.",
  },
  {
    q: "¿Puedo probar el servicio antes de comprar?",
    a: "Sí, contáctanos por WhatsApp o Telegram y con gusto te ayudamos a coordinar una prueba.",
  },
  {
    q: "¿Cómo instalo el servicio?",
    a: "Es muy sencillo: tras contratar tu plan te enviamos tus credenciales de acceso y una guía paso a paso. Además, te ayudamos por WhatsApp durante toda la instalación en tu Smart TV, Fire Stick, Android, iPhone, iPad o PC.",
  },
  {
    q: "¿Qué velocidad de Internet necesito?",
    a: "Recomendamos al menos 15 Mbps para ver contenido en HD y 25 Mbps o más para 4K. Con una conexión estable disfrutarás de una reproducción fluida y sin cortes.",
  },
  {
    q: "¿Puedo usar mi cuenta en varios dispositivos?",
    a: "Sí. Según el plan que elijas puedes tener de 2 a 5 conexiones simultáneas, para que tu familia disfrute en diferentes dispositivos al mismo tiempo.",
  },
  {
    q: "¿Cómo renuevo mi plan?",
    a: "La renovación es muy fácil: escríbenos por WhatsApp o Telegram antes de que venza tu plan y lo reactivamos al instante, manteniendo tus mismos datos de acceso.",
  },
  {
    q: "¿Qué métodos de pago aceptan?",
    a: "Puedes coordinar tu pago de forma rápida y segura contactándonos por WhatsApp o Telegram. Te indicamos las opciones disponibles para tu país.",
  },
];
